<template>
    <div class="row">
        <div class="col col-sm-12 pr-0">
            <v-select v-model="user" label="text"
                      :options="users"
                      :filterable="false"
                      @input="onGroupChange"
                      @search="onUserSearch"
                      @search:focus="onUserFocus"
                      :disabled="disabled"
                      :class="{invalid : $v.user.$error}">
                <template slot="option" slot-scope="option" v-if="option">
                    <div v-html="option.text"></div>
                </template>
                <template slot="selected-option"
                          v-if="user && user.text">
                    <div v-html="user.text"
                         @click="$eventBus.$emit('search:focus')"></div>
                </template>
                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
            </v-select>
        </div>
        <!--<div class="col col-sm-1 p-0" v-if="addBtn && hasPermission('EB_CLIENT')">-->
        <!--<button class="btn btn-primary p-0 btn-with-vselect" type="button" @click="addGroup">...</button>-->
        <!--</div>-->

        <!--<b-modal size="xl" ref="add-client-modal" :title="$t('client.title')"-->
        <!--:cancel-only="true"-->
        <!--:ok-only="true"-->
        <!--:no-close-on-backdrop="true"-->
        <!--:no-close-on-esc="true">-->
        <!--<clientModal :showModal="true" @change="onClientModalChange"></clientModal>-->
        <!--</b-modal>-->
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import {required /*, requiredUnless, minLength*/} from 'vuelidate/lib/validators';
    import {validationMixin} from 'vuelidate';


    export default {
        name: "AgentSelect",
        mixins: [validationMixin],
        components: {},
        data() {
            return {
                processing: false,
                province: null,
                users: [],
                user: null,
                filter: initFilterModel(),
            }
        },
        props: {
            data: {
                type: Object
            },
            addBtn: {
                type: Boolean,
                default: true
            },
            required: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        validations() {
            return {
                user: {
                    required: required
                }
            }
        },
        methods: {
            onGroupChange() {
                // this.$emit('change', this.ownerClient);
                this.$emit('input', this.user);
            },
            onUserSearch(search, loading) {
                loading(true);
                this.users = [];
                this.filter.search = search;
                this.$http.post('/user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onUserFocus() {
                this.users = [];
                this.filter.search = '';
                this.$http.post('/user/agent', this.filter)
                    .then(res => {
                        this.users = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
        },
        created() {
            this.processing = true;

            setTimeout(() => {
                if (this.data) {
                    this.user = this.data;
                }
            }, 2000);

        }
    }
</script>

<style scoped>

</style>
